/// <reference types="@eturi/ts-helpers" />
import { addBreadcrumb, captureException, setContext } from '@sentry/core';
import { createReduxTransformer } from 'rtk-slice-transformer';
export const sentryBreadcrumb = (msgOrBreadcrumb) => {
    const breadcrumb = { level: 'info' };
    if (typeof msgOrBreadcrumb === 'string') {
        breadcrumb.message = msgOrBreadcrumb;
    }
    else {
        Object.assign(breadcrumb, msgOrBreadcrumb);
    }
    addBreadcrumb(breadcrumb);
};
/**
 * Capture a sentry exception. If a context is passed (string, object, etc.),
 * it will be added to the scope.
 */
export const sentryError = (e, ctx) => {
    captureException(e, (s) => {
        if (!ctx)
            return s;
        const normalizedCtx = typeof ctx === 'string' ? { message: ctx } : ctx;
        return s.setContext('Error Ctx', normalizedCtx);
    });
};
/**
 * Previously I created a version of this because of a bug in sentry/react. A link to this is
 * referenced below. However, that bug has since been fixed, and this mainly exists because it's
 * so trivial with `rtk-slice-transformer` and it's more efficient. Additionally, sentry/react
 * packs its own types which may not follow those of redux.
 *
 * @see https://github.com/getsentry/sentry-javascript/issues/2963
 * @param transformer
 * @param onError
 */
export const createSentryReduxEnhancer = (transformer, onError) => createReduxTransformer(transformer, (transformedAction, transformedState) => {
    if (transformedAction != null) {
        addBreadcrumb({
            category: 'redux.action',
            data: transformedAction,
            type: 'info',
        });
    }
    setContext('redux.state', transformedState ?? null);
}, onError);
//# sourceMappingURL=index.js.map